import * as React from 'react';
import * as styles from './styles.css';

import { ConditionalWrapper } from '@cian/conditional-component';
import { useIsDesktop } from '@cian/valuation-utils-component';
import { Header1, Header3, LinkButton } from '@cian/ui-kit';

import { Wrapper } from '../Wrapper';
import { applicationFormUrl } from '../../constants/urls';

export interface IContactsProps {
  onClickGoToApplicationForm(): void;
}

export const Contacts: React.FC<IContactsProps> = ({ onClickGoToApplicationForm }) => {
  const isDesktop = useIsDesktop();

  return (
    <div className={styles['container']}>
      <Wrapper>
        <div className={styles['card']}>
          <div className={styles['title']}>
            <ConditionalWrapper if={isDesktop} ThenComponent={Header1} ElseComponent={Header3}>
              Обратитесь к риелтору-партнёру Циан по любому вопросу с недвижимостью
            </ConditionalWrapper>
          </div>
          <LinkButton
            data-testid="Contacts_link"
            href={applicationFormUrl}
            onClick={onClickGoToApplicationForm}
            theme="fill_primary"
            size="L"
          >
            Подобрать риелтора
          </LinkButton>
        </div>
      </Wrapper>
    </div>
  );
};

Contacts.displayName = 'Contacts';
